import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {arraySwapItems, HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class ReorderLessonsStore implements SaveStateHolder {
  @observable
  readonly lessonIds: number[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly unitId: number,
              lessonIds: number[]) {
    makeObservable(this);
    this.lessonIds = lessonIds.slice();
    this.save = null;
  }

  @action
  swap(index1: number, index2: number) {
    arraySwapItems(this.lessonIds, index1, index2);
  }

  @action
  complete = () => {
    if (this.save?.isPending === true)
      return;
    const reordered = this.lessonIds.slice();
    this.save = contentLoaders.x4unit.orderChildren(this.unitId, reordered);
  };
}
